import { UserSubscription } from '@creditsights/api-ui-web';
import { DisplayType, DisplayTypeKey } from '../../pages/Feeds/FeedLeftContainer/DisplayTypeSelection';
import useFetchUserPermissions from '../permissions/useFetchUserPermissions';
import useLocalStorage from './useLocalStorage';

const getInitialDisplayType = (subscription: UserSubscription): DisplayType => {
  return subscription === UserSubscription.CR || subscription === UserSubscription.CR_LFI
    ? DisplayType.Expanded
    : DisplayType.Cozy;
};

const useDisplayType = (): readonly [DisplayType, (value) => void] => {
  const { data: userPermissions } = useFetchUserPermissions();
  return useLocalStorage<DisplayType>(DisplayTypeKey, getInitialDisplayType(userPermissions!.userSubscription));
};

export default useDisplayType;
